<template>
  <Baseline>
    <template #content>
      <v-row align="center" justify="center">
        <v-col cols="10" sm="6" md="4" lg="3">
          <Login/>
        </v-col>
      </v-row>
    </template>
  </Baseline>
</template>

<script>
import Baseline from '@/components/baseline'
import Login from '@/components/login'

export default{

  components:{
    Baseline,
    Login
  }
}
</script>